"use client"
import { create } from "zustand"

import type { TopNavbarVariants } from "@/components/navigation/top-nav/TopNavbarContainer"

interface TopNavbarStore {
  variants: TopNavbarVariants | undefined
  setVariants: (variants: TopNavbarVariants | undefined) => void
  height: number | undefined
  setHeight: (height: number | undefined) => void
}

export const useTopNavbarStore = create<TopNavbarStore>(set => ({
  variants: undefined,
  setVariants: variants => set({ variants }),
  height: undefined,
  setHeight: height => set({ height }),
}))
